/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { Grid, TextField } from '@material-ui/core';
import Tooltip from 'react-bootstrap/Tooltip';
import Checkbox from '@material-ui/core/Checkbox';
import { Button, OverlayTrigger } from 'react-bootstrap';
import Box from '@mui/material/Box';
import _, { range } from 'lodash';
import React, { useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Fieldset from '../../../../SharedModules/Fieldset/Fieldset';
import SelectBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithBox';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';

import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import { ManufactureTableHead } from './gridComponents/tableHead';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  convertToFourDigitYear,
  validateQuarter,
  validateDate,
  autoFormateDate,
} from '../../../../SharedModules/utilities/utilities';
import * as Constants from '../../../../SharedModules/AppConstants';
import {
  getPlanTypeValues,
  getRebateProgrameList,
  getManufacturerList,
  getDRAMSQuarter,
  getSearchResult,
  setRebatePercentData,
  setSearchInput,
  setReduxDataSearchScreen,
  getFirstSummaryQtr,
} from '../Store/action';
import { compareDate } from '../../../../SharedModules/utilities/dateUtilities';
import {
  TO_DATE_GREATER_THAN_FROM,
  REBATE_SELECT,
  ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
} from '../../../../SharedModules/Errors/constantMessageData';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';

import Spinner from '../../../../SharedModules/Spinner/Spinner';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';

export default function RebatePercentOfSpend(props) {
  const dispatch = useDispatch();

  const {
    planType: planTypeList,
    errors,
    isLoading,
    selectedPlanType,
    rebateProgramValue,
    rebateProgramNameValue,
    rebateProgramList: rebateProgramListData,
    manufacturerList: resultanufacturerList,
    isManufacturerListFetched,
    dramsQtr,
    firstSumQtr,
    searchResult,
    scrollDownManufacturers: scrollDownManufacturersValue,
    rangeType: rangeTypeValue,
    selectedRowIndexValue,
  } = useSelector((state) => state?.sharedState?.RebatePercentOfSpendReducer);
  const reduxDataSearch = useSelector(
    (state) => state?.sharedState?.RebatePercentOfSpendReducer?.searchScreen
  );
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const [radioList, setRadioList] = React.useState([]);
  const [planType, setPlanType] = React.useState(
    reduxDataSearch?.planTypeCd || selectedPlanType
  );
  const [selectList, setSelectList] = React.useState([]);
  const [rebateProgram, setRebateProgram] = React.useState(
    reduxDataSearch?.rebateProgram || rebateProgramValue
  );
  const [rebateProgramName, setRebateProgramName] = React.useState(
    rebateProgramNameValue
  );
  const [errorList, setErrorList] = React.useState(errors);
  const [fullScreenView, setfullScreenView] = React.useState(false);
  const handleFullScreenView = () => {
    setfullScreenView(!fullScreenView);
  };

  const [isAllManufacturersSelected, setIsAllManufacturersSelected] =
    React.useState(reduxDataSearch?.isAllManufacturersSelected);
  const [scrollDownManufacturers, setScrollDownManufacturers] = React.useState(
    scrollDownManufacturersValue
  );
  const [manufacturerList, setManufacturerList] = React.useState([]);
  const [manufacturerSelected, setManufacturerSelected] = React.useState([
    'ALL',
  ]);
  const [manufacturerSelectedName, setManufacturerSelectedName] =
    React.useState(['ALL']);
  const [rangeType, setRangeType] = React.useState(
    reduxDataSearch?.rangeType || rangeTypeValue
  );
  // To know that search button is pressed
  const [isSearchClicked, setSearchClicked] = React.useState(false);
  const [fromQuarter, setFromQuarter] = React.useState(
    reduxDataSearch?.fromQtr || ''
  );
  const [toQuarter, setToQuarter] = React.useState(
    reduxDataSearch?.toQtr || ''
  );
  const [dramsStartQtr, setDramsStartQtr] = React.useState('');
  const [selectedRowIndex, setSelectedRowIndex] = React.useState(
    selectedRowIndexValue
  );

  // on scroll default top level
  const handleScrollToEvent = () => {
    window.scrollTo(0, 0);
  };

  // For No Data validation
  // React.useEffect(() => {
  //   setErrorList(errors);
  // }, [errors]);

  // set data for plan type radio list
  React.useEffect(() => {
    if (planTypeList?.PLAN_TYPE_CD?.length > 0) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
      const tempPlanType = planList.find(
        (item) => item.value === userDefaults?.planTypeCd
      );
      setPlanType(planType || tempPlanType?.value);
    }
  }, [planTypeList]);

  // API to get the plan type list
  React.useEffect(() => {
    handleScrollToEvent();
    dispatch(getPlanTypeValues({ codeDomainList: ['PLAN_TYPE_CD'] }));
  }, []);

  const rebatepgmDropdown = async (planType) => {
    const rebateProgramListData = await dispatch(
      getRebateProgrameList(planType)
    );
    const list = rebateProgramListData.map((val) => ({
      ...val,
      id: val.rebateProgramCd,
      name: `${val.rebateProgramCd} | ${val.shortDescr}`,
    }));
    // if (list.length) {
    setSelectList(list);
    const tempRebateProgram = list.find(
      (item) => item.id === userDefaults?.rebateProgramCd
    );
    if (tempRebateProgram) {
      setRebateProgram(tempRebateProgram.id);
      setRebateProgramName(tempRebateProgram.name);
    } else {
      setRebateProgram(''); // Set to an empty string if tempRebateProgram is not found
      setRebateProgramName('');
    }
    // }
  };

  // After each time once plantype changes rebateprogram list get updated using this API call
  React.useEffect(() => {
    if (planType) {
      rebatepgmDropdown(planType);
      const errors = errorList.filter((e) => e.field !== 'noData');
      setErrorList([...errors]);
    }
  }, [planType]);

  // To get manufacturer List
  React.useEffect(() => {
    if (!isManufacturerListFetched) {
      dispatch(
        getManufacturerList({
          planType: 'fd',
          asMode: 1,
        })
      );
    }
  }, [dispatch, isManufacturerListFetched]);

  // Manufacturer Grid From API
  React.useEffect(() => {
    setManufacturerList(
      resultanufacturerList?.rebatePercentOfSpendMfgGridVO || []
    );
  }, [resultanufacturerList]);

  React.useEffect(() => {
    if (rebateProgram) {
      dispatch(getDRAMSQuarter({ rebateProgCode: rebateProgram }));
      dispatch(getFirstSummaryQtr({ rebateProgCode: rebateProgram }));
    }
  }, [rebateProgram]);
  React.useEffect(() => {
    if (dramsQtr) {
      setDramsStartQtr(dramsQtr);
    }
  }, [dramsQtr]);

  //Resetting error message on input fields change
  React.useEffect(()=> {
    dispatch(setSearchInput({ errors: [] }));
  }, [isAllManufacturersSelected, planType, rebateProgram, rangeType, fromQuarter, toQuarter])

  // To change the manufacturer grid as per the plan type selection
  const handleOnChangeEvent = (value, name) => {
    if (name === 'planTypeCd') {
      if (value === 'ST' || value === 'FD') {
        dispatch(
          getManufacturerList({
            planType: 'st',
            asMode: 1,
          })
        );
      }
      if (value === 'SUPP' || value === 'COMM') {
        dispatch(
          getManufacturerList({
            planType: 'supp',
            asMode: 1,
          })
        );
      }
    }
  };

  // On selection of the row data
  const onSelectionChanged = (e) => {
    const selectedRows = e.api?.getSelectedRows();
    dispatch(
      setReduxDataSearchScreen({
        ...reduxDataSearch,
        selectedRow: selectedRows,
      })
    );
    const selectedMfgId = selectedRows?.map((item) => item.mfgId);
    const selectedIndexes = [];
    manufacturerList.forEach((item, index) => {
      if (selectedMfgId.indexOf(item.mfgId) != -1) {
        selectedIndexes.push(index);
      }
    });
    setSelectedRowIndex(selectedIndexes);
    if (
      selectedRows?.length === manufacturerList?.length
      // || selectedRows.length === 0
    ) {
      setManufacturerSelected(['ALL']);
      setManufacturerSelectedName(['ALL']);
    } else {
      const selectedManuId = [];
      const selectedManuName = [];
      for (let i = 0; i < selectedRows?.length; i += 1) {
        selectedManuId.push(selectedRows[i].mfgId);
        selectedManuName.push(selectedRows[i].mfgName);
      }
      selectedManuId.sort();
      setManufacturerSelected(selectedManuId);
      setManufacturerSelectedName(selectedManuName);
    }
    const errors = errorList.filter((error) => error.field !== 'manufacturer' && error.field != "noData");
    setErrorList([...errors]);
  };

  React.useEffect(() => {
    // Ensure initial state consistency
    if (!isAllManufacturersSelected) {
      setSelectedRowIndex([]);
      setManufacturerSelected([]);
      setManufacturerSelectedName([]);
    }
  }, [manufacturerList?.length > 0]);

  // function to conver 2 digit year to 4 digit ear
  const convertTo4DigitQtr = (value) => {
    const tempValue = value?.split('Q');
    tempValue.splice(1, 1, convertToFourDigitYear(tempValue[1]));
    return tempValue.join('Q');
  };

  // handing by default multiple row selection function
  const onFirstDataRendered = (params) => {
    if (reduxDataSearch?.selectedRow?.length > 0) {
        params.forEachNode(
          (node) =>
            -1 !==
              reduxDataSearch?.selectedRow.findIndex((x) => {
                return x?.mfgId == node.data?.mfgId;
              }) && node.setSelected(true)
        );
    }
    };

  // Handle onblur events for date and quarter
  const handleOnBlur = (type, input) => {
    const value = autoFormateDate(input);
    let localErrors = errorList;
    let toError = [];
    if (type === 'fromQtr') {
      localErrors = localErrors.filter((error) => error.field != 'qtr');
      const qtrErr = validateQuarter(value, 'qtr',true,'fromQtr');

      if (qtrErr.length === 0) {
        const qtr = value.length == 4 ? convertTo4DigitQtr(value) : value;
        setFromQuarter(qtr);
        dispatch(
          setReduxDataSearchScreen({
            ...reduxDataSearch,
            fromQtr: qtr,
          })
        );
      } else {
       
        localErrors = [...localErrors, ...qtrErr];
      }
      if (!toQuarter) {
        setToQuarter(qtrErr?.length===0? value.toUpperCase():'');
        dispatch(
          setReduxDataSearchScreen({
            ...reduxDataSearch,
            fromQtr: value.toUpperCase(),
            toQtr: qtrErr?.length===0? value.toUpperCase():'',
          })
        );
      }
    }
    if (type === 'toQtr') {
      // setToDate(value.toUpperCase());
      if (value != '') {
        toError = validateQuarter(value, 'toQtr');
        if (toError.length === 0) {
          const qtr = value.length == 4 ? convertTo4DigitQtr(value) : value;
          setToQuarter(qtr);
          dispatch(
            setReduxDataSearchScreen({
              ...reduxDataSearch,
              toQtr: qtr,
            })
          );
        }
        localErrors = [...localErrors, ...toError];
      }
    }
    setErrorList(localErrors);
  };

  const d = new Date();
  const currentQtr = `${+(
    Math.floor(d.getMonth() / 3) + 1
  ).toString()}Q${d.getFullYear()}`;

  // Handle all the side effect on search button get clicked errorhandling and dispacting action and navigate to next screen
  const handleSearchClick = () => {
    let allErrors = [];
    const manuError = [];
    if (rebateProgram === '-1' || !rebateProgram) {
      allErrors.push({
        field: 'rebateProgram',
        message: REBATE_SELECT,
      });
    }

    if (fromQuarter.length === 0 && rangeType === 'selectedRange') {
      allErrors.push({
        field: 'qtr',
        message: 'From Quarter is required',
      });
    }
    if (allErrors.length === 0 && rangeType === 'selectedRange') {
      if (compareDate(fromQuarter, toQuarter)) {
        allErrors.push({
          field: 'fromDate>toDate',
          message: TO_DATE_GREATER_THAN_FROM,
        });
      }
    }
    if (manufacturerSelected.length === 0) {
      allErrors.push({
        field: 'manufacturer',
        message: ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
      });
    }
    allErrors = [...allErrors, ...errorList];
    setErrorList(allErrors);

    const qtrRange = {
      all: { from: '1Q1991', to: currentQtr },
      drams: { from: dramsStartQtr, to: currentQtr },
      firstSummary: { from: firstSumQtr, to: currentQtr },
      selectedRange: {
        from: fromQuarter,
        // to: toQuarter === '' ? fromQuarter : toQuarter,
        to: toQuarter,
      },
    };

    if (allErrors.length === 0) {
      dispatch(setRebatePercentData([]));
      setSearchClicked(true);
      // Variable to get fullname of rebate program from rebate program list(selectList)
      let rebateProgrameName =
        selectList?.find((item) => item.rebateProgramCd === rebateProgram) ||
        {};
      rebateProgrameName = `${rebateProgrameName?.rebateProgramCd} - ${
        rebateProgrameName?.shortDescr || ''
      }`;
      dispatch(
        setSearchInput({
          errors: allErrors,
          selectedPlanType: planType,
          rebateProgramValue: rebateProgram,
          rebateProgramName,
          manufacturerSelected,
          manufacturerSelectedName,
          rebateProgrameName,
          fromQuarter: qtrRange[rangeType]?.from,
          toQuarter: qtrRange[rangeType]?.to,
          isAllManufacturersSelected,
          rangeType,
          selectedRowIndexValue: selectedRowIndex,
          scrollDownManufacturers,
          displayObj: {
            rebateProgramList: rebateProgramListData,
            rebateProgramValue: rebateProgram,
            rangeType,
            rebateProgrameName,
            fromQuarter: qtrRange[rangeType]?.from,
            toQuarter: qtrRange[rangeType]?.to,
            isAllManufacturersSelected,
            manufacturerList: manufacturerList,
          },
        })
      );

      dispatch(
        getSearchResult({
          rebateProgramCode: rebateProgram,
          fromQtr: qtrRange[rangeType]?.from,
          mfgIds: manufacturerSelected,
          toQtr:
            toQuarter === '' && rangeType === 'selectedRange'
              ? qtrRange[rangeType]?.from
              : qtrRange[rangeType]?.to,
          isAllMfg: manufacturerSelected[0] === 'ALL' ? 1 : 0,
        })
      );
    }
    /*
        if all the  error is cleaered then it will go to if block and
        set store value and navigate to Displayy Screen
    * */

    if (allErrors.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  // For No Data validation
  React.useEffect(() => {
    setErrorList(errors);
    if (isSearchClicked && errors.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [errors]);

  if (isSearchClicked && searchResult && searchResult.length > 0) {
    setSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/maufacturer',
      value: 'Display Rebate Percent Of Spend Rpt',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    if (props.history) {
      props.history.push({
        pathname: '/maufacturer',
      });
      dispatch(clearReduxForFilterAndSort('/maufacturer'));
    }
  }

  const errorMessages = [...new Set(errorList?.map((obj) => obj.message))];
  return (
    <div className="tabs-container">
      {!fullScreenView && (
        <div className="tab-body">
          <Spinner load={isLoading} />
          <DisplayErrorMessages
            errorMessages={[...new Set(errorMessages.map((l) => l))]}
          />
          <CustomSeparator
            parent1="Summary Reports"
            parent2="Rebate Percent Of Spend"
          />
          <div className="row">
            <div className="col-4 frr-two-col-radio">
              <RadioGroupComponent
                data-testid="RebatePercentOfSpend_PlanType"
                id="filter-plan-by-radio-btn-action"
                labelName="Plan Type"
                required
                optionList={radioList || []}
                defaultValue={planType}
                filterAction={(value) => {
                  setPlanType(value);
                  dispatch(
                    setReduxDataSearchScreen({
                      ...reduxDataSearch,
                      rebateProgram: -1,
                      planTypeCd: value,
                    })
                  );
                  setRebateProgram('-1');
                  handleOnChangeEvent(value, 'planTypeCd');
                  const errors = errorList.filter(
                    (error) => error.field !== 'rebateProgram'
                  );
                  setErrorList([...errors]);
                }}
                className="log-batch-filter-radio frr-checkInvoiceRadio"
              />
            </div>
            <div className="col-4">
              <>
                <Fieldset label="Rebate Program" required>
                  <div>
                    <SelectBoxComponent
                      data-testid="RebatePercentOfSpend_RebateProgram"
                      id="filter-plan-by-radio-btn-action"
                      labelName="Rebate Program"
                      required
                      select
                      selectOne
                      optionList={selectList || []}
                      // defaultValue={rebateProgram || ''}
                      defaultValue={
                        selectList
                          .map((option) => option.id)
                          .includes(rebateProgram)
                          ? rebateProgram
                          : ''
                      }
                      filterAction={(value) => {
                        setRebateProgram(value);
                        setRebateProgramName(value);
                        dispatch(
                          setReduxDataSearchScreen({
                            ...reduxDataSearch,
                            rebateProgram: value,
                          })
                        );
                        if (value == '-1') {
                          setErrorList([
                            ...errorList,
                            {
                              field: 'rebateProgram',
                              message: REBATE_SELECT,
                            },
                          ]);
                        } else {
                          const errors = errorList.filter(
                            (error) => error.field !== 'rebateProgram'
                          );
                          setErrorList([...errors]);
                        }
                      }}
                      isError={
                        errorList?.find(
                          (error) => error.field === 'rebateProgram'
                        )?.message
                      }
                    />
                  </div>
                </Fieldset>
              </>
            </div>
            <div className="col-4 mt-5">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isAllManufacturersSelected}
                    color="primary"
                    name="allManufacturers"
                    onChange={async (e) => {
                      setIsAllManufacturersSelected(
                        !isAllManufacturersSelected
                      );
                      dispatch(
                        setReduxDataSearchScreen({
                          ...reduxDataSearch,
                          selectedRow: [],
                          isAllManufacturersSelected:
                            !isAllManufacturersSelected,
                        })
                      );
                      setScrollDownManufacturers(!scrollDownManufacturers);
                      if (!isAllManufacturersSelected) {
                        setManufacturerSelected(['ALL']);
                        setManufacturerSelectedName(['ALL']);
                      } else {
                        setManufacturerSelected([]);
                        setManufacturerSelectedName([]);
                      }

                      const elem = document.getElementById('abc11');
                      if (scrollDownManufacturers) {
                        //setTimeout(() => {
                           await Promise.resolve();
                          const a = elem?.scrollIntoView();
                        //}, 1000);
                      }
                      const errors = errorList?.filter(
                        (error) => error.field !== 'manufacturer' && error.field != "noData"
                      );
                      setErrorList([...errors]);
                    }}
                    isError={
                      errorList?.find((error) => error.field === 'manufacturer')
                        ?.message
                    }
                  />
                }
                label="All Manufacturers"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-10">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">
                  Quarter Range <span className="mandatory"> *</span>{' '}
                </legend>
                <div className="row">
                  <div className="col ml-2">
                    <FormControl>
                      <RadioGroup
                        row
                        name="QTR"
                        data-testid="RebateSum_QTR"
                        required
                        value={rangeType}
                        onChange={(e) => {
                          setRangeType(e.target.value);
                          setFromQuarter('');
                          setToQuarter('');
                          dispatch(
                            setReduxDataSearchScreen({
                              ...reduxDataSearch,
                              rangeType: e.target.value,
                              fromQtr: '',
                              toQtr: '',
                            })
                          );
                          if (rangeType === 'selectedRange') {
                            const errors = errorList.filter(
                              (error) =>
                                error.field !== 'qtr' &&
                                error.field !== 'toQtr' &&
                                error.field !== 'fromDate>toDate'
                            );
                            setErrorList([...errors]);
                          }
                        }}
                      >
                        <FormControlLabel
                          value="all"
                          control={<Radio />}
                          label="All"
                          data-test="all"
                        />
                        <FormControlLabel
                          value="drams"
                          control={<Radio />}
                          label="DRAMS Invoice Start Quarter"
                          data-test="drams"
                        />
                        <FormControlLabel
                          value="firstSummary"
                          control={<Radio />}
                          label="First Summary Report Quarter"
                          data-test="firstSummary"
                        />
                        <FormControlLabel
                          value="selectedRange"
                          control={<Radio />}
                          label="Selected Range"
                          data-test="selectedRange"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                </div>
                <div className="row">
                  <div className="col-2 mui-custom-form input-md field-xl ml-2 mr-0">
                    <TextField
                      label="From"
                      id="From"
                      disabled={rangeType != 'selectedRange'}
                      data-testid="rpos-qtr-from"
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 6 }}
                      required
                      name="from"
                      value={rangeType === 'selectedRange' ? fromQuarter : ''}
                      error={
                        errorList?.filter((error) => error.field === 'qtr')
                          ?.length > 0
                          ? 'mandate-fields'
                          : ''
                      }
                      helperText={
                        errorList?.find((error) => error.field === 'qtr')
                          ?.message
                      }
                      className="mandate-fields"
                      onBlur={(e) => handleOnBlur('fromQtr', e.target.value)}
                      onChange={(e) => {
                        const { value } = e.target;
                        setFromQuarter(value.toUpperCase());
                        const localErrors = errorList.filter(
                          (error) => error.field != 'qtr'
                        );
                        setErrorList(localErrors);
                      }}
                    />
                  </div>
                  <div className="col-2 mui-custom-form input-md field-xl ml-0">
                    <TextField
                      label="To"
                      id="To"
                      disabled={rangeType != 'selectedRange'}
                      data-testid="rpos-qtr-to"
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 6 }}
                      name="to"
                      value={
                        rangeType === 'selectedRange' && toQuarter
                          ? toQuarter
                          : ''
                      }
                      error={
                        errorList?.filter(
                          (error) =>
                            error.field === 'toQtr' ||
                            error.field === 'fromDate>toDate'
                        )?.length > 0
                          ? 'mandate-fields'
                          : ''
                      }
                      helperText={
                        errorList?.find(
                          (error) =>
                            error.field === 'toQtr' ||
                            error.field === 'fromDate>toDate'
                        )?.message
                      }
                      className="mandate-fields"
                      onBlur={(e) => handleOnBlur('toQtr', e.target.value)}
                      onChange={(e) => {
                        const { value } = e.target;
                        setToQuarter(value.toUpperCase());
                        const localErrors = errorList.filter(
                          (error) =>
                            error.field != 'toQtr' &&
                            error.field !== 'fromDate>toDate'
                        );
                        setErrorList(localErrors);
                      }}
                    />
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
          <div className="row" style={{ marginTop: 15 }}>
            <div className="btn-wrapper col-12">
              <Button
                data-testid="Search"
                onClick={handleSearchClick}
                className="btn btn-success btn-search float-right"
              >
                <SVGComponent iconName="Icon-search" /> Search
              </Button>
            </div>
          </div>
        </div>
      )}
      <div className="row" id="abc11">
        {!isAllManufacturersSelected && (
          <div className="col-12 unallocated">
            <TableGrid
              onSelectionChanged={onSelectionChanged}
              // selectRowIndex={selectedRowIndexValue}
              rowData={manufacturerList}
              gridDataRendered={onFirstDataRendered}
              helpMessage
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={fullScreenView ? '100vh' : viewPortHeight_355}
              columnDefs={ManufactureTableHead}
              rowSelection="multiple"
              rowMultiSelectWithClick
              data-testid="onEditingStopped"
              fileName="Manufacturer List"
              enterMovesDown
              suppressCellFocus
              singleClickEdit
              exportFile
              hideColumnsInPdf
              frameworkComponents={{
                TextBoxRender: (cellInfo) => {
                  const name = cellInfo?.value;

                  if (name && name.length > 30) {
                    return (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                      >
                        <div>{name}</div>
                      </OverlayTrigger>
                    );
                  }
                  return <div>{name}</div>;
                },
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
}
